import React from 'react';

const FractalDetails = ({ fractal }) => {
  return (
    <div>
      <h3>Detalles de {fractal.nombre}</h3>
      {/* Renderizar el árbol aquí */}
      <pre>{JSON.stringify(fractal, null, 2)}</pre>
    </div>
  );
};

export default FractalDetails;
